import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { Promotion } from 'ish-core/models/promotion/promotion.model';
import { ModalDialogLinkComponent } from 'ish-shared/components/common/modal-dialog-link/modal-dialog-link.component';

/**
 * The Promotion Details Component displays a link to a modal dialog
 * This dialog provides information in detail about the specified promotion.
 *
 * @example
 * <ish-promotion-details
 *   [promotion]="promotion"
 * ></ish-promotion-details>
 */
@Component({
  selector: 'ish-promotion-details',
  templateUrl: './promotion-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ServerHtmlDirective, ModalDialogLinkComponent, TranslateModule],
})
export class PromotionDetailsComponent {
  readonly promotion = input.required<Promotion>();
}
